// extracted by mini-css-extract-plugin
module.exports = {"promo":"styles_promo__1ZAJv","promoDetailedWrapper":"styles_promoDetailedWrapper__3r49F","clear":"styles_clear__1Bo6_"};